import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpntb3ceem: FaireProductEntity = {
  token: "p_xpntb3ceem",
  type: "product",
  name: "Hello World Organic Baby Knotted Ginger Gown",
  brandToken: "b_4ktjmwa4",
  brandName: "Urban Baby Co.",
  imageUrl: "https://cdn.faire.com/fastly/c4fa9a9dff659d3411b0f80279b1f3324eb7116d4066624be47a2f6dd6871aec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/901730481f473cd11df5c7a72a92f6f52b6e063aca791d9bb844c8fa91dd0aa5.jpeg"
  ],
  priceDollars: 17.25,
  description: "•Size: 0-3 months\n•Screen printed in-house in Denver, CO.\n•Garment is made from 100% soft organic cotton, single jersey.\n•Features fold-over cuffs and an adjustable tie bottom. \n•No harmful chemicals, pesticides, or artificial dyes.\n•Sustainably sourced and ethically produced.\n•As with any organic, non-bleached cotton some fabric imperfections are normal.\n•Urban Baby Co. logo will be printed on the back neck of garment.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:16.130Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
